import {mapGetters} from "vuex";

export const rankMixin = {
  props: {
    month: null,
    type: null,
    tabName: null,
  },
  data(){
    return {
      fulfillmentOption:[
        {id:'AFN',text:'FBA'},
        {id:'MFN',text:'FBM'},
      ]
    }
  },
  computed: {
    ...mapGetters(['dashboardCurrency', 'marketAuthType', 'countryMarket']),
    //用于控制跟店铺授权挂钩的板块 是否显示蒙板和调用数据接口
    showStoreMask:function (){
      return this.marketAuthType.find(r=> r.authType==='market')?.auth
    },
    filter: {
      get() {
        return {
          month: this.month,
          type: this.type,
          tabName: this.tabName,
          currency: this.dashboardCurrency,
          countryMarket:this.countryMarket
        }
      },
      set(val) {
        this.filter = val
      }
    }
  },
  watch: {
    filter: {
      handler: function() {
        if(this.tabName === this.rankName){
          this.$gjNoticeQuery();
        }
      }
    }
  },
  methods:{
    // 计算排名
    rank(row,index){
      if(!row.hasChild&&this.type === 'variationAsin'){
        return ''
      }else {
        return index+1
      }
    },
  },
};
